// Espelha `normalizeLetter` do player real (app-recreativa/src/features/crosswords/
// store.ts): tira acento e força maiúscula, como a regex do legado no INSERT. O
// gabarito é gravado sem acento, então o editor precisa autorar do mesmo jeito.

/** Normaliza uma única letra digitada (acento → base, maiúscula). */
export function normalizeLetter(value: string): string {
  return value
    .replace(/[ÁÀÂÃ]/gi, 'a')
    .replace(/[ÉÈÊ]/gi, 'e')
    .replace(/[ÍÌÎ]/gi, 'i')
    .replace(/[ÓÒÔÕ]/gi, 'o')
    .replace(/[ÚÙÛ]/gi, 'u')
    .toUpperCase();
}

/** Normaliza uma palavra inteira letra a letra. */
export function normalizeWord(value: string): string {
  return normalizeLetter(value);
}
